import { render, staticRenderFns } from "./barScroll.vue?vue&type=template&id=50a3742e&scoped=true"
import script from "./barScroll.vue?vue&type=script&lang=js"
export * from "./barScroll.vue?vue&type=script&lang=js"
import style0 from "./barScroll.vue?vue&type=style&index=0&id=50a3742e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a3742e",
  null
  
)

export default component.exports